<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col class="employee_roles" :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="roleList">
            <Button-group>
              <template v-for="(item, index) in roleList">
                <template v-if="index < 5">
                  <Button v-if="item.selected" type="primary" @click="roleControl(index)" :key="index">{{ item.title }}</Button>
                  <div class="pseudoButton" v-if="!item.selected" @click="roleControl(index)" :key="index">
                    <span class="title">{{ item.title }}</span>
                    <Icon
                      type="md-create"
                      v-if="getPermission('role_update') && roleControlStatus"
                      class="roleEdit"
                      @click="editRole(item.roleId, item.title)"
                    />
                    <Icon
                      type="md-close"
                      v-if="getPermission('role_delete') && roleControlStatus"
                      class="roleDel"
                      @click="delRole(item.roleId)"
                    />
                  </div>
                </template>
              </template>
              <template v-if="roleList.length > 5">
                <Dropdown transfer style="margin-left: 10px" class="select-dropdown-menu-styles">
                  <Button :type="moreTitle !== $t('key1005166') ? 'primary' : 'default'">
                    {{ moreTitle }}
                    <Icon type="md-arrow-dropdown"/>
                  </Button>
                  <template #list>
                    <div class="wid100P p8">
                      <Input v-model="roleSearchText" :placeholder="$t('key1005169')" clearable @on-change="filterRoles"/>
                    </div>
                    <Dropdown-menu>
                      <Dropdown-item v-for="(item, index) in filteredRoleList" :key="item.id">
                        <template>
                          <span @click="roleControl(index, 2, filteredRoleList)">{{ item.title }}</span>
                          <Icon
                            type="md-create"
                            v-if="getPermission('role_get') && roleControlStatus"
                            class="roleEdit"
                            @click="editRole(item.roleId, item.title)"
                          />
                          <Icon
                            type="md-close"
                            v-if="getPermission('role_delete') && roleControlStatus"
                            class="roleDel"
                            @click="delRole(item.roleId)"
                          />
                        </template>
                      </Dropdown-item>
                      <p class="width_180 text-align-center color-999" v-if="filteredRoleList.length <= 0">{{ $t('key1000104') }}</p>
                    </Dropdown-menu>
                  </template>
                </Dropdown>
              </template>
            </Button-group>
            <div class="manageRole" v-if="!roleControlStatus" @click="manageRole">
              <span class="icon iconfont">&#xe634;</span> {{ $t('key1005172') }}
            </div>
            <div class="manageOperate" v-else-if="roleControlStatus">
              <span v-if="getPermission('role_insert')" class="icon iconfont addRole"
                @click="$refs['roleBox'].initRoleData('add', null)">&#xe671; {{ $t('key1000718') }}</span>
              <span class="icon iconfont returnRole" @click="returnRole">&#xe62f; {{ $t('key1000786') }}</span>
            </div>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002820')">
              <Input :placeholder="$t('key1005170')" v-model.trim="pageParams.searchValue" @on-enter="search"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1005171')">
              <local-tabButton :tabButtonList="enableList" @selectStatus="enableBtn"></local-tabButton>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <div class="mr15 sort_options_box">
        <span>{{ $t('key1003034') }}</span>
        <Button-group>
          <template v-for="(item, index) in buttonGroupModel">
            <Button
              v-if="item.selected" type="primary" @click="modifyTheSort(index, item.status)" :key="index">
              {{ item.title }}
              <Icon type="md-arrow-round-up" v-if="item.status && item.selected"></Icon>
              <Icon type="md-arrow-round-down" v-if="!item.status && item.selected"></Icon>
            </Button>
            <Button
              v-if="!item.selected" @click="modifyTheSort(index, item.status)" :key="index">
              {{ item.title }}
              <Icon type="md-arrow-round-up" v-if="item.status && item.selected"></Icon>
              <Icon type="md-arrow-round-down" v-if="!item.status && item.selected"></Icon>
            </Button>
          </template>
        </Button-group>
      </div>
      <Button class="mr15" v-if="getPermission('ymsCoreUserInfo_insert')" type="primary"
        icon="md-add" @click="$refs['staffModalbox'].initStaffData('add', null)">
        {{ $t('key1005173') }}
      </Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="500"
        :loading="tableLoading"
        :columns="columns"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray"
        :current="curPage">
      </Page>
    </div>
    <!--新增、编辑、查看员工的弹窗-->
    <staffModal ref="staffModalbox" :roleList="roleList" @saveSuccess="saveSuccess"></staffModal>
    <!--新增、编辑、角色的弹窗-->
    <roleModal ref="roleBox" @saveSuccess="saveSuccess"></roleModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import staffModal from "./staffModal";
import roleModal from "./roleModal";

export default {
  name: "employeeList",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      buttonGroupModel: [
        {
          type: 'userName',
          selected: true,
          status: true, // true up false down
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005164') // 按姓名
        }, {
          type: 'email',
          selected: false,
          status: true, // true up false down
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005165') // '按邮箱'
        }
      ],
      roleControlStatus: false,
      pageParams: {
        pageNum: 1,
        pageSize: 10,
        status: null,
        roleId: null,
        orderBy: 'userName',
        upDown: 'up',
        searchValue: null
      },
      pageParamsStatus: false,
      total: 0,
      curPage: 1,
      moreTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005166'),
      enableList: [
        {selected: true, value: null, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {selected: false, value: '1', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462')},
        {selected: false, value: '0', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')}
      ],
      roleList: [],
      columns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'),
          key: 'email',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002331'),
          key: 'userName',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002813'),
          key: 'mobile',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005167'),
          align: 'center',
          sortable: true,
          key: 'lastLoginTime',
          render: (h, params) => {
            return h('span', params.row.lastLoginTime ? v.$uDate.dealTime(params.row.lastLoginTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          align: 'center',
          render: (h, params) => {
            return params.row.ymsCoreStatus === '0' ? h('span', {
              class: 'stopStatus'
            }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')) : h('span', {
              class: 'openStatus'
            }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'action',
          align: 'center',
          width: 200,
          fixed: 'right',
          render: (h, params) => {
            let isAdmin = params.row.isAdmin === '1';
            if (params.row !== undefined) {
              let userId = params.row.userId;
              let ymsCoreStatus = params.row.ymsCoreStatus === '0';
              return h('optsButtonList', {
                props: {
                  operationList: [
                    {
                      text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                      show: v.getPermission('ymsCoreUserInfo_query'),
                      clickFn: () => {
                        v.$refs['staffModalbox'].initStaffData('look', userId);
                      }
                    },
                    {
                      text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                      show: v.getPermission('ymsCoreUserInfo_update'),
                      clickFn: () => {
                        v.$refs['staffModalbox'].initStaffData('edit', userId);
                      }
                    },
                    {
                      text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                      show: !isAdmin && ymsCoreStatus && v.getPermission('ymsCoreUserInfo_enable'),
                      clickFn: () => {
                        v.enableStatus(userId);
                      }
                    },
                    {
                      text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                      show: !isAdmin && !ymsCoreStatus && v.getPermission('ymsCoreUserInfo_disable'),
                      clickFn: () => {
                        v.disableStatus(userId);
                      }
                    }
                  ]
                },
                on: {
                  setWidth(value) {
                    if (value) {
                      v.optionBtnWidth.push(value);
                      params.column.width = Math.max(...v.optionBtnWidth);
                      v.$forceUpdate();
                    }
                  }
                }
              });
            }
          }
        }
      ],
      tableData: [],
      roleSearchText: '', // 搜索框输入的内容
      filteredRoleList: [], // 过滤后的角色列表
    };
  },
  created() {
    let v = this;
    v.getPermissionCallback('yms_employeeList').then(() => {
      v.getRoleList(); // 获取角色的数据
      v.getUserList();// 获取用户列表
    });
  },
  methods: {
    // 获取所有角色列表的数据
    getRoleList() {
      let v = this;
      if (v.getPermission('role_query')) {
        v.axios.post(api.post_role_query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            let pos = [];
            pos[0] = {
              selected: true,
              roleId: '',
              merchantId: '',
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
            };
            data.forEach((n, i) => {
              i = i + 1;
              pos[i] = {
                selected: false,
                roleId: n.roleId,
                merchantId: n.merchantId,
                title: n.roleName
              };
            });
            v.roleList = pos;
            // 初始化时显示所有超过5个的角色
            v.filteredRoleList = v.roleList.slice(5);
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 启用按钮
    enableStatus(params) {
      let v = this;
      v.axios.put(api.put_ymsCoreUserInfo_enable + '?userId=' + params).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
          v.pageParamsStatus = true;
        }
      });
    },
    // 停用按钮
    disableStatus(params) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003176'),
        onOk: () => {
          v.axios.put(api.put_ymsCoreUserInfo_disable + '?userId=' + params).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 头部筛选：启用、停用按钮的切换
    enableBtn(index, value) {
      let v = this;
      v.pageParams.status = value;
      v.enableList.forEach((n, i) => {
        n.selected = i === index;
      });
    },
    // 角色按钮的切换
    roleControl(index, type, data) {
      let v = this;
      if (index === 0) {
        v.pageParams.roleId = null;
      }
      if (!v.roleControlStatus) {
        v.moreTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005166');
        v.roleList.forEach((n, i) => {
          n.selected = false;
          if (type === 2) {
            data.map((item, idx) => {
              if (idx === index) {
                v.moreTitle = item.title;
                item.selected = true;
                v.pageParams.roleId = item.roleId;
              } else {
                item.selected = false;
              }
            });
          } else {
            if (i === index) {
              n.selected = true;
              v.pageParams.roleId = n.roleId;
            } else {
              n.selected = false;
            }
          }
        });
      }
      v.resetRoleSearch();
    },
    // 查询按钮
    search() {
      let v = this;
      v.curPage = 1;
      v.pageParams.pageNum = 1;
      v.pageParamsStatus = true;
    },
    // 管理员工、角色按钮
    manageRole() {
      let v = this;
      v.roleControl(0);
      v.roleControlStatus = true;
    },
    // 退出员工、角色编辑状态
    returnRole() {
      let v = this;
      v.roleControlStatus = false;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.pageParams.searchValue = '';
      v.enableBtn(0, null);
      v.roleControl(0);
      v.pageParamsStatus = true;
    },
    // 新增、编辑员工成功后，更新列表数据
    saveSuccess() {
      let v = this;
      v.pageParamsStatus = true;
      v.roleControlStatus = false;
      v.getRoleList();
    },
    // 编辑角色
    editRole(roleId, title) {
      let v = this;
      v.$refs['roleBox'].initRoleData('edit', roleId, title);
      v.resetRoleSearch();
    },
    // 删除角色
    delRole(id) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005168'),
        onOk: () => {
          v.axios.delete(api.delete_role + id, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000779'));
              v.resetRoleSearch();
              v.getRoleList();
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 获取员工列表
    getUserList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsCoreUserInfo_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsCoreUserInfo_query, JSON.stringify(v.pageParams)).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.tableData = data.list || [];
            v.total = data.total;
            v.$nextTick(() => {
              v.tableLoading = false;
            });
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 角色搜索
    filterRoles() {
      if (!this.roleSearchText.trim()) {
        // 如果搜索框为空，显示所有超过5个的角色
        this.filteredRoleList = this.roleList.slice(5);
      } else {
        // 根据角色名称进行过滤
        this.filteredRoleList = this.roleList.slice(5).filter(item => {
          return item.title.toLowerCase().includes(this.roleSearchText.toLowerCase());
        });
      }
    },
    // 重置角色搜索数据
    resetRoleSearch() {
      let v = this;
      setTimeout(() => {
        v.roleSearchText = '';
        v.filterRoles();
      }, 1000);
    },
  },
  watch: {
    pageParamsStatus(n) {
      let v = this;
      if (n) {
        v.getUserList();
        v.pageParamsStatus = false;
      }
    },
  },
  components: {
    staffModal,
    roleModal
  }
};
</script>

<style lang="less" scoped>
.filter_box {
  .employee_roles {
    display: flex;
    margin-bottom: 24px;
    margin-left: 50px;

    .manageRole {
      color: #39f;
      cursor: pointer;
      height: 32px;
      line-height: 32px;
      margin-left: 20px;
    }

    .manageOperate {
      display: flex;
      position: relative;
      top: 5px;
      margin-left: 20px;

      .addRole {
        cursor: pointer;
        color: #39f;
        font-size: 14px;
      }

      .returnRole {
        cursor: pointer;
        color: #d13131;
        margin-left: 15px;
        font-size: 14px;
      }

    }

    .ivu-btn-group {
      display: flex;
    }

    .title {
      color: #666;
      font-size: 14px;
    }

    .roleEdit {
      font-size: 15px;
      margin: 0 6px;
      color: #39F;
      cursor: pointer;
    }

    .roleDel {
      font-size: 17px;
      color: #cf2a28;
      cursor: pointer;
    }

    .pseudoButton {
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: 0;
      font-weight: 400;
      text-align: center;
      vertical-align: middle;
      -ms-touch-action: manipulation;
      touch-action: manipulation;
      cursor: pointer;
      background-image: none;
      white-space: nowrap;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      padding: 0 15px;
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      border-radius: 4px;
      transition: color .2s linear, background-color .2s linear, border .2s linear;
      color: #495060;
      background-color: #f7f7f7;
      border: 1px solid #dddee1;
      box-sizing: border-box;
    }

    .pseudoButton:not(:first-child):not(:last-child) {
      border-radius: 0
    }

    .ivu-btn-group:not(.ivu-btn-group-vertical) > .pseudoButton:last-child:not(:first-child) {
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
    }

    /deep/ .select-dropdown-menu-styles {
      .ivu-select-dropdown {
        max-height: 350px !important;
        overflow-y: auto;
      }
    }
  }
}
</style>
